import { GridColDef } from '@microservices/wiskey-react-table-component'

import { ObjectDataRecord } from '@types'

export const getColumnsInternalIds = (
  columns: GridColDef<ObjectDataRecord, any, any>[]
): Record<string, string> => {
  return Object.fromEntries(columns.map(column => [column.field, (column as any).internalId]))
}
